import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UserProfileReporting } from '@liquitics/transaction/dist/lib/profiles';
import { ReportDashboardPersistedConfig } from '@liquitics/transaction/dist/lib/web-api';
import { AppConfig } from '../../app.config';
import { AwsUtil } from '../../authentication/aws.service';

@Component({
    selector: 'app-report-dashboard-permission',
    templateUrl: './report-dashboard-permission.component.html',
    styleUrls: ['./report-dashboard-permission.component.scss']
})
export class ReportDashboardPermissionComponent implements OnInit {
    @Input()
    designers: string[];

    @Input()
    reportDashboardPersistedConfig: ReportDashboardPersistedConfig;

    @Output()
    private formReady: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    public formGroup: FormGroup;
    isReportingAdmin: boolean;
    currentUser: string;

    constructor(
        private appConfig: AppConfig,
        private awsUtil: AwsUtil,
    ) {
        const reportingProfile: UserProfileReporting = this.appConfig.activeUserProfile as UserProfileReporting;
        this.isReportingAdmin = reportingProfile.isReportDashboardAdmin();
        this.currentUser = this.awsUtil.jwtService.getUserCredentials().getUserName();
        this.formGroup = new FormGroup({
            owner: new FormControl(),
            publisher: new FormControl(),
            collaborators: new FormControl(),
            viewers: new FormControl(),
        });
    }

    ngOnInit() {
        this.formReady.emit(this.formGroup);
        this.formGroup.get('owner').setValue(this.reportDashboardPersistedConfig.meta?.owner);
        this.formGroup.get('publisher').setValue(this.reportDashboardPersistedConfig.meta?.publisher);
        this.formGroup.get('collaborators').setValue(this.reportDashboardPersistedConfig.meta?.collaborators);
        this.formGroup.get('viewers').setValue(this.reportDashboardPersistedConfig.meta?.viewers);
    }

    get owner() { return this.formGroup.get('owner'); }
    get publisher() { return this.formGroup.get('publisher'); }
}
